import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { AlertTriangle, FileText } from "lucide-react";
import RiskScoreBadge from "./RiskScoreBadge";

export default function BidFolder({ rfp, index = 0 }) {
  const isAmber = rfp.priority === "high" && rfp.missing_responses;
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.07 }}
      whileHover={{ y: -4 }}
      className="folder-3d"
      data-testid={`bid-folder-${rfp.id}`}
    >
      <Link to={`/bid/${rfp.id}`} className={`block folder-3d ${isAmber ? "folder-amber" : ""}`}>
        <div className="folder-tab">{rfp.id.slice(-8).toUpperCase()}</div>
        <div className="folder-body p-5 pt-7 min-h-[200px] flex flex-col">
          <div className="flex items-start justify-between gap-2">
            <FileText className="w-4 h-4 text-amber-500/70 mt-1" />
            <div className="flex items-center gap-1.5">
              <RiskScoreBadge risk={rfp.risk} />
              {rfp.status === "extracting" && (
                <span className="font-mono-data text-[9px] tracking-[0.2em] uppercase text-amber-500 animate-pulse">
                  AI Parsing
                </span>
              )}
              {isAmber && (
                <span className="font-mono-data text-[9px] tracking-[0.2em] uppercase text-amber-500 inline-flex items-center gap-1">
                  <AlertTriangle className="w-3 h-3" /> Priority
                </span>
              )}
            </div>
          </div>
          <div className="font-display text-xl mt-2 leading-tight line-clamp-2">{rfp.title}</div>
          <div className="font-mono-data text-xs text-text-secondary mt-2 truncate">
            {rfp.operator}
          </div>
          <div className="mt-auto pt-4 border-t border-white/5 flex justify-between items-end">
            <div>
              <div className="font-mono-data text-[9px] tracking-[0.2em] uppercase text-text-secondary">Deadline</div>
              <div className="font-mono-data text-sm">{rfp.deadline || "—"}</div>
            </div>
            <div className="text-right">
              <div className="font-mono-data text-[9px] tracking-[0.2em] uppercase text-text-secondary">Quotes</div>
              <div className="font-display text-xl text-amber-500">{rfp.quote_count ?? 0}</div>
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
